var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-83c72545.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-26b86ff1.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M16.667.01v16.657H0a39.247 39.247 0 0 1 .003-.684c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c.222.002.445.005.667.01Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M5.333 1.705V16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 .87-4.158 4.467-6.17Z"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#E94B35", d: "M16 0v16h-5.334V.314A50.525 50.525 0 0 1 16 0Z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m19.6 17.219.889 1.415h2.528v4.935L21.119 20.6l-2.554 4.072h1.242l.251-.449h2.118l1.634 2.934 1.635-2.934h2.118l.25.449h1.243L26.502 20.6l-1.898 2.968v-2.727h1.139l.846-1.345h-1.985v-.863h2.528l.889-1.415H19.6Zm7.423 6.039-.52-.932-.52.932h1.04Zm-5.385 0h-1.04l.52-.932.52.932Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m18.2 20.813-.901.628.318-1.051-.875-.664 1.098-.022.36-1.037.36 1.037 1.098.022-.875.664.318 1.05-.901-.627Zm11.334 0-.902.628.318-1.051-.875-.664 1.098-.022.36-1.037.361 1.037 1.098.022-.875.664.318 1.05-.901-.627Zm-8.867 7-.902.628.319-1.051-.875-.664 1.097-.022.36-1.037.361 1.037 1.098.022-.875.664.318 1.05-.901-.627Zm6.266 0-.9.628.317-1.051-.875-.664 1.098-.022.36-1.037.36 1.037 1.099.022-.875.664.318 1.05-.902-.627Zm-3.067 2.334-.9.627.317-1.051-.875-.663 1.098-.023.36-1.037.361 1.037 1.098.023-.875.663.318 1.05-.902-.626Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagAtf = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagAtf_default = SvgFlagAtf;
export {
  FlagAtf_default as default
};
